@if (article.new) {
  <span class="badge bg-success me-1">{{ 'NEW' | translate }}</span>
}
@if (article.setitem) {
  <span class="badge bg-warning">{{ 'SETITEM' | translate }}</span>
}
@if (article.volume_price && article.volume_price.length && !showroomMode) {
  <span class="badge bg-info">{{ 'VOLUME_PRICES' | translate }}</span>
}
@if (article.is_lease && article.article_type === 'F') {
  <span class="badge badge-lease me-1">{{ 'LEASE_AVAILABLE' | translate }}</span>
}
@if (article.dropshipment && showroomMode) {
  <span class="badge badge-default availableForDs" ngbTooltip="{{'AVAILABLE_FOR_DROPSHIPMENT'|translate}}"
    placement="bottom">
    <small><i class="material-icons">home</i></small>
  </span>
}
@if (article.mandatory_battery || article.has_mandatory_item) {
  <span class="badge badge-battery rounded-pill text-bg-light "><u>{{ 'MANDATORY_BATTERY' | translate }}</u></span>
}
@if (article.top_performer) {
  <div class="badge position-absolute"><img src="./assets/images/top-performer-wide.png" class="top-performer"/>
    <span class="position-absolute text-white performance-label">TOP<br><b class="performer">PERFORMER</b></span>
  </div>
}
@if (article.is_msl) {
  <span class="badge bg-dark rounded-pill text-light d-inline-flex align-items-center"><i class="text-success me-1 material-icons" style="font-size: 0.8rem;">assignment_late</i> {{ 'MUST_STOCK_LIST' | translate }}</span>
}